var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.355,
    height: 26.692,
    viewBox: "0 0 23.355 26.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-trash-alt",
    d: "M1.668,24.19a2.5,2.5,0,0,0,2.5,2.5H19.185a2.5,2.5,0,0,0,2.5-2.5V6.673H1.668Zm14.18-13.346a.834.834,0,1,1,1.668,0V22.521a.834.834,0,0,1-1.668,0Zm-5,0a.834.834,0,1,1,1.668,0V22.521a.834.834,0,0,1-1.668,0Zm-5,0a.834.834,0,1,1,1.668,0V22.521a.834.834,0,0,1-1.668,0ZM22.521,1.668H16.265l-.49-.975A1.251,1.251,0,0,0,14.655,0H8.7A1.237,1.237,0,0,0,7.58.693l-.49.975H.834A.834.834,0,0,0,0,2.5V4.171A.834.834,0,0,0,.834,5H22.521a.834.834,0,0,0,.834-.834V2.5A.834.834,0,0,0,22.521,1.668Z",
    fill: "#3e3e3e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a1b22fdf549d8385dc3707bf479fb2d6.svg";
export { ForwardRef as ReactComponent };